import { Box } from '@mui/material';

import {
  PAGE_HEADER_TAG_DOT_SX,
  PAGE_HEADER_TAG_FRAME_SX,
  PAGE_HEADER_TAG_LABEL_SX,
  PAGE_HEADER_TAG_SX,
  PAGE_HEADER_TAG_VALUE_CENTERED_SX,
  PAGE_HEADER_TAG_VALUE_SX,
} from '../styles';

import type { PageHeaderTagProps } from './types';

export default function PageHeaderTag({ testId, label, value, dotColor }: PageHeaderTagProps) {
  return (
    <Box data-testid={testId} sx={PAGE_HEADER_TAG_SX}>
      <Box aria-hidden sx={PAGE_HEADER_TAG_FRAME_SX} />
      <Box component="span" sx={PAGE_HEADER_TAG_LABEL_SX}>
        {label}
      </Box>
      <Box sx={dotColor ? PAGE_HEADER_TAG_VALUE_SX : PAGE_HEADER_TAG_VALUE_CENTERED_SX}>
        {dotColor ? <Box aria-hidden sx={PAGE_HEADER_TAG_DOT_SX} bgcolor={dotColor} /> : null}
        {value}
      </Box>
    </Box>
  );
}
